import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { WithdrawForm } from '@/features/consumer/withdraw-form';
import { useTrack } from '@/features/tracking/useTrack';

export const Route = createFileRoute(
  '/(consumer)/_authenticated/my-wallet/withdraw/'
)({
  component: WithdrawPage,
});

function WithdrawPage() {
  const navigate = useNavigate();
  const track = useTrack();
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.BackButton
          onClick={() => {
            track('click', {
              eventAction: 'clickButton',
              eventCategory: 'myWallet',
              eventDescription: 'clickBack',
              eventLabel: 'myWallet',
              screenName: 'myWalletPage',
            });
            navigate({ to: '/my-wallet' });
          }}
        />
        <HeaderDashboard.Title>Withdraw</HeaderDashboard.Title>
      </HeaderDashboard>
      <WithdrawForm />
    </div>
  );
}
